import { render, staticRenderFns } from "./select-consent-agreement.vue?vue&type=template&id=87a4617e&scoped=true&"
import script from "./select-consent-agreement.vue?vue&type=script&lang=js&"
export * from "./select-consent-agreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a4617e",
  null
  
)

export default component.exports